import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { EMPTY, from } from 'rxjs';
import { catchError, first, mergeMap } from 'rxjs/operators';
import { globalCacheBusterNotifier } from 'ts-cacheable';
import { Owner } from '../../models/Owner';
import { AreaStore } from '../../services/area/area.store';
import { CorrespondenceStore } from '../../services/correspondence/correspondence.store';
import { StorageService } from '../../services/storage.service';
import { UserStore } from '../../services/user.store';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  public loginForm: FormGroup;
  public queryParams$: any;
  public returnUrl: string;

  constructor(
    protected userStore: UserStore,
    protected router: Router,
    protected formBuilder: FormBuilder,
    protected toastController: ToastController,
    protected route: ActivatedRoute,
    protected areaStore: AreaStore,
    protected correspondenceStore: CorrespondenceStore,
    protected storage: StorageService
  ) {
    const url = window.location;
    let email = null;
    let pincode = null;
    if (url.hash.length > 1) {
      const view = location.hash.replace('#', '');
      const parts = view.split('&');
      if (parts.length === 3) {
        email = parts[1];
        pincode = parts[2];
      }
    }
    this.loginForm = this.formBuilder.group({
      email: [email, Validators.required],
      pincode: [pincode, Validators.required],
    });
  }

  async ngOnInit() {
    globalCacheBusterNotifier.next();
    this.areaStore.clear();
    this.correspondenceStore.clear();
    await this.storage.clear();
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  async login(): Promise<void> {
    if (this.loginForm.invalid) {
      const toast = await this.toastController.create({
        message: 'Invalid credentials',
        duration: 3000,
        position: 'top',
      });
      return await toast.present();
    }

    const email = this.loginForm.get('email').value;
    const pinCode = this.loginForm.get('pincode').value;
    this.userStore
      .login({
        slug: 'akpr',
        email: email ? email.trim() : '',
        pincode: pinCode ? pinCode.trim() : '',
      })
      .pipe(
        first(),
        catchError((errorResponse: string) => {
          return from(
            this.toastController.create({
              message:
                errorResponse ||
                'Cannot login. Make sure all login details are correct.',
              duration: 3000,
              position: 'top',
            })
          ).pipe(
            mergeMap((toast: HTMLIonToastElement) =>
              from(toast.present()).pipe(mergeMap(() => EMPTY))
            )
          );
        })
      )
      .subscribe((user: Owner) => {
        if (user) {
          this.router.navigateByUrl(this.returnUrl);
        }
      });
  }
}
